module.exports = __webpack_public_path__ + "static/sport/bgi-message.90127c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/road/bgi-message.png
// module id = A8OC
// module chunks = 0